document.addEventListener('DOMContentLoaded', function() {
  const noIndexFollowPatterns = [
    '?variant',
    'pr_prod_strat=',
    'pr_rec_id=',
    'pr_rec_pid=',
    'pr_ref_pid=',
    'pr_seq=',
    '&currency=',
    'gid://shopify',
    'ProductVariant',
    'login_with_shop/authorize',
  ];

  const currentUrl = window.location.href;
  const canonicalUrl = document.querySelector("link[rel='canonical']")?.href;

  let shouldNoIndex = false;

  if (
    currentUrl !== canonicalUrl ||
    noIndexFollowPatterns.some(pattern => currentUrl.includes(pattern))
  ) {
    shouldNoIndex = true;
  }

  if (shouldNoIndex) {
    let metaRobots = document.querySelector('meta[name="robots"]');
    if (!metaRobots) {
      metaRobots = document.createElement('meta');
      metaRobots.name = 'robots';
      document.head.appendChild(metaRobots);
    }
    metaRobots.content = 'noindex,follow';
  }
});